import React from "react"
import { Button, Modal } from "react-bootstrap"

interface DisclaimerModalProps {
  show: boolean
  disclaimerText: string
  onAgree: () => void
  onCancel: () => void
}

const DisclaimerModal = ({
  show,
  disclaimerText,
  onAgree,
  onCancel,
}: DisclaimerModalProps): JSX.Element => (
  <Modal show={show} onHide={onCancel} scrollable>
    <Modal.Header closeButton>
      <Modal.Title>Media Use Disclaimer</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p style={{ whiteSpace: "pre-wrap" }}>{disclaimerText}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onAgree}>
        Agreed
      </Button>
    </Modal.Footer>
  </Modal>
)

export default DisclaimerModal
